import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Template.title_cd',
    defaultMessage: 'Solusi Cepat dan Mudah Membuat Dokumen Hukum',
  },
  description: {
    id: 'app.containers.Template.description',
    defaultMessage: 'Pilih dokumen, isi form sederhana, unduh dokumen dari advokat berpengalaman yang siap Anda pakai',
  },
  cta_text: {
    id: 'app.containers.Template.cta',
    defaultMessage: 'Lihat Daftar Dokumen'
  },
});
